import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const CCard: any = styled.div`
  margin-top: 34px;
  width: 343px;
  height: 192px;
  border-radius: 16px;
  background-image: linear-gradient(to top, ${ColorPalette.HEX.ChineseBlack2}, ${ColorPalette.HEX.DavysGrey3});
  position: relative;

  &.back::after {
    content: '';
    display: block;
    position: absolute;
    top: 42px;
    width: 343px;
    height: 32px;
    background-color: rgba(${ColorPalette.RGB.White}, 0.08);
  }
`;

CCard.Chip = styled.div`
  width: 37px;
  height: 28px;
  position: absolute;
  top: 24px;
  left: 24px;
  background: url('/images/payment/cc-chip.svg') no-repeat center;
`;

CCard.Flag = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  position: absolute;
  right: 24px;
  top: 22px;
  background-image: url('/images/payment/cc/payment.svg');

  &.visa {
    background-image: url('/images/payment/cc/visa.svg');
  }
  &.mastercard {
    background-image: url('/images/payment/cc/mastercard.svg');
  }
  &.amex {
    background-image: url('/images/payment/cc/amex.svg');
  }
  &.naranja {
    background-image: url('/images/payment/cc/naranja.png');
    background-color: ${ColorPalette.HEX.White};
  }
`;

CCard.Number = styled.div`
  position: absolute;
  top: 96px;
  left: 24px;
  color: ${ColorPalette.HEX.Cultured4};
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.19em;
`;

CCard.Expiry = styled.div`
  position: absolute;
  bottom: 24px;
  right: 24px;
  color: ${ColorPalette.HEX.Cultured4};
  font-size: 16px;
  font-weight: 600;
  text-align: right;
`;

CCard.HolderName = styled.div`
  position: absolute;
  bottom: 24px;
  left: 24px;
  color: ${ColorPalette.HEX.Cultured4};
  font-size: 16px;
  font-weight: 600;
`;

CCard.Cvv = styled.div`
  position: absolute;
  bottom: 24px;
  left: 24px;
  color: ${ColorPalette.HEX.Cultured4};
  font-size: 16px;
  font-weight: 600;
`;
